export default (url, objParams) => {
  let newUrl = url;
  for (let key in objParams){
    const re = new RegExp(`{${key}}`, 'g');
    newUrl = newUrl.replace(re, objParams[key]);
  }
  return newUrl;
}


// WEBPACK FOOTER //
// ./src/util/initUrl.js